import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

export class Certificate {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/Certificate.ts